/* src/app/forms/from-to-form/from-to-form.component.scss */
.mat-mdc-tab-body.mat-tab-body-active {
  height: 60vh;
}
.block {
  animation: 1s fadeIn;
  animation-fill-mode: forwards;
  opacity: 0;
  animation: fadeIn 10s;
  animation-delay: 40s;
  animation-fill-mode: forwards;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.content {
  padding: 5px;
  height: calc(100% - 48px);
}
.mktplace {
  overflow: auto;
  height: 100%;
}
.gridclass {
  height: 100%;
  width: 100%;
  position: absolute;
}
.mat-tab-body-content {
  height: auto !important;
}
.tabcontent {
  height: 100%;
  overflow-y: auto;
}
.cardcontent {
  height: 25%;
}
.mat-mdc-tab-group {
  height: 100%;
}
:host ::ng-deep .custom-tabs {
}
:host ::ng-deep .custom-tabs .mat-tab-body-wrapper {
  height: 100%;
}
.transformimage {
  transform: scale(1.5);
}
.title {
  width: 100%;
  padding: 6px;
  text-align: right;
  font-size: 100%;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
/*# sourceMappingURL=from-to-form.component.css.map */
